export default __webpack_public_path__ + "static/media/mail.250dcae1.svg";